module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#26304d"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "g-color-white text-center g-pt-20"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('div', {
    staticClass: "row text-center g-py-5"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4 g-mb-30 g-color-white"
  }, [_c('img', {
    staticClass: "contact-us-icon g-mb-10",
    attrs: {
      "src": require("../../../../static/assets/img/icons/Help Page Icons/Mail_ContactUs.png")
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "h5 g-font-weight-600 g-mb-5"
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-16"
  }, [_vm._v("support@onesight.org")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 g-mb-30 g-color-white"
  }, [_c('img', {
    staticClass: "contact-us-icon g-mb-10",
    attrs: {
      "src": require("../../../../static/assets/img/icons/Help Page Icons/Address_ContactUs.png")
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "h5 g-font-weight-600 g-mb-5"
  }, [_vm._v("Address")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-16"
  }, [_vm._v("13455 Branchview Ln. "), _c('br'), _vm._v(" Dallas, TX 75234")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 g-mb-30 g-color-white"
  }, [_c('img', {
    staticClass: "contact-us-icon g-mb-10",
    attrs: {
      "src": require("../../../../static/assets/img/icons/Help Page Icons/Mobile_ContactUs.png")
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "h5 g-font-weight-600 g-mb-5"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('span', {
    staticClass: "d-block g-font-size-16"
  }, [_vm._v("(866) 385-0447")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-54b64331", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54b64331"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/helpData/HelpInfo.vue
// module id = 506
// module chunks = 3